"use client";

import ActionFloatingButtons from "@/components/layout/ActionFloatingButtons";
import AppFooter from "@/components/layout/footer/AppFooter";
import AppHeader from "@/components/layout/header/AppHeader";
import MobileHeader from "./header/MobileHeader";
import type { ReactNode } from "react";
import { usePathname } from "next/navigation";

import { cn } from "@/lib/utils";

const NO_FOOTER_PREFIXES = ["/account-settings"];
const FULL_BLEED_PREFIXES = ["/book-for-me"];

export const MinimalLayoutShell = ({ children }: { children: ReactNode }) => {
  const pathname = usePathname();
  const hideFooter = NO_FOOTER_PREFIXES.some((p) => pathname?.includes(p));
  const isFullBleed = FULL_BLEED_PREFIXES.some((p) => pathname?.includes(p));

  return (
    <div className="flex min-h-screen min-w-0 flex-col bg-white">
      <AppHeader layout="default-active" gSearch={true} />

      <div className="fixed top-0 z-50 w-full">
        <MobileHeader gSearch={true} />
      </div>

      <main
        className={cn(
          "relative w-full flex-1",
          isFullBleed ? "mt-0 md:mt-0 p-0" : "md:mt-35 mt-18 py-4 md:px-4 px-2",
        )}
      >
        {children}
      </main>

      <ActionFloatingButtons />
      {!hideFooter && <AppFooter />}
    </div>
  );
};
